export const DEFAULT_TIMEZONE = 'Europe/Bratislava';

/** Returns the browser's IANA timezone with a stable fallback for older clients. */
export default function getBrowserTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || DEFAULT_TIMEZONE;
  } catch {
    return DEFAULT_TIMEZONE;
  }
}

/** Adds the browser timezone to an API query without changing its other parameters. */
export function withBrowserTimezone<T extends Record<string, unknown>>(query: T): T & { timezone: string } {
  return { ...query, timezone: getBrowserTimezone() };
}
